import { useCallback } from "react";

import { FrameStencil } from "../../types";
import { sliceItemUpdate } from "../../utils";
import { UpdateFrameStencils } from "./use-update-frame-stencils";

export interface UpdateStencilRotationProps {
  stencil: FrameStencil;
  rotation: number;
}

export type UpdateStencilRotation = (props: UpdateStencilRotationProps) => void;

export const useUpdateStencilRotation = (updateFrameStencils: UpdateFrameStencils) =>
  useCallback<UpdateStencilRotation>(
    ({ stencil, rotation }) => {
      updateFrameStencils((prevState) => {
        if (!prevState) return prevState;

        const foundStencil = prevState.find((stencilItem) => stencilItem.id === stencil.id);

        if (!foundStencil) return prevState;

        return sliceItemUpdate({ item: { ...foundStencil, rotate: rotation }, arr: prevState });
      });
    },
    [updateFrameStencils]
  );
